import React, { useState } from "react";
import Form from "../../components/Form";
import TitleUnderlined from "../../components/TitleUnderlined";
import Button from "../../components/Button";
import Divider from "../../components/Divider";
import APIInterface from "../../tools/APIInterface";
import CloudError from "../../tools/ClourError";
import Attendee from "../../models/Attendee";
import AttendeeStatus from "../../models/AttendeeStatus";
import Swal from "sweetalert2";

const ScanTicketView = () => {
    const [code, setCode] = useState('');
    const [attendee, setAttendee] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleData = (e) => {
        setCode(e.target.value)
    }

    const updateTicket = (status) => {
        attendee.status = status;
        if(!isLoading) {
            setIsLoading(true);
            APIInterface.updateTicket(code, attendee)
            .then((response) => {
                console.log(response);
                Swal.fire({
                    icon: 'success',
                    title: 'Confirmación',
                    text: 'Boleto sellado',
                    showConfirmButton: true,
                })
                .then((value) => {
                    // redirect
                    setAttendee(null);
                    setCode('');
                    document.getElementById('folio').focus();
                    document.getElementById('folio').value = '';
                })
                .catch((error) => {
                    console.error(error);
                });
            })
            .catch((error) => {
                console.error(error);
            })
            setIsLoading(false);
        }
    }

    return(<div className="pt-5 pb-5" id="ticketDetail">
    
    <TitleUnderlined>Ingreso al <span className="embercom_overlined">Evento</span></TitleUnderlined>
    <br />
    <br />
    <Form submitCallback={() => {
         APIInterface.validateTicket(code)
         .then((response) => {
            if(response.status === 200){
                let newAttendee = Attendee.fromJSON(response.data);
                setAttendee(newAttendee);
                document.getElementById('folio').focus();
            }
         })
         .catch((error) => {
            console.log(error);
            CloudError.error(error);
            // Limpismod el input
            setCode('');
            document.getElementById('folio').focus();
            document.getElementById('folio').value = '';
         });
    }}>
        <div className="form-group" style={{maxWidth: '70%'}}>
            <label htmlFor="folio" className="semibold"><b>Escanee el código de barras</b></label>
            <div className="d-flex justify-content-between">
                <input type="text" className="form-control" id="folio" autoFocus name="folio" aria-describedby="folio" required onChange={handleData}  />
                <Button className="ml-4" style={{minWidth: '27%',marginLeft: '2rem'}}>Consultar <img src={require('../../assets/arrow_next.png')} alt="arrowNext" /></Button>
            </div>
        </div>
    </Form>
    <br />
    <br />
    {attendee !== null ?
        <>
            <h4 className="text-uppercase"><b>Información del visitante</b></h4>
            <Divider />
            <table className="table border-0">
                <tbody>
                    <tr className="border-0">
                        <td className="border-0">
                            <label><b>Boleto</b></label><br/>
                            <b>1</b>
                        </td>
                        <td className="border-0">
                            <div className="form-group">
                                <label><b>Nombre</b></label>
                                <input className="form-control" type="text" value={attendee.fullName} defaultValue={attendee.fullName} disabled />
                            </div>
                        </td>
                        <td className="border-0" colSpan="2">
                            <div className="form-group">
                                <label>Evento</label>
                                <input className="form-control" type="text" value={attendee.order.event.title} defaultValue={attendee.order.event.title} disabled />
                            </div>
                        </td>
                    </tr>
                    <tr className="border-0">
                        <td className="border-0"><b></b></td>
                        <td className="border-0">
                            <div className="form-group">
                                <label>Fecha</label>
                                <input className="form-control" type="text" defaultValue={attendee.order.event.startDate} disabled value={attendee.order.event.startDate} />
                            </div>
                        </td>
                        <td className="border-0">
                            <div className="form-group">
                                <label>Hora</label>
                                <input className="form-control" type="text" value={attendee.order.event.startTime} defaultValue={attendee.order.event.startTime} disabled />
                            </div>
                        </td>
                        {attendee.email ? (
                        <td className="border-0">
                            <div className="form-group">
                                <label>Correo</label>
                                <input className="form-control" type="text" value={attendee.email} defaultValue={attendee.email} disabled />
                            </div>
                        </td>
                        ) : attendee.phoneNumber ? (
                        <td className="border-0">
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input className="form-control" type="text" value={attendee.phoneNumber} defaultValue={attendee.phoneNumber} disabled />
                            </div>
                        </td>
                        ) : null}
                    </tr>
                </tbody>
            </table>
            {attendee.status === AttendeeStatus.AVAILABLE ?
            <>
                <div className="available d-flex justify-content-between">
                    <p className="m-0">Boleto disponible</p>
                    <img src={require('../../assets/correct.png')} alt="correct" width="32px" height="29px" />
                </div>
                <br />
                <div className="d-flex justify-content-between">
                    {/* <button className="row m-0 reject align-items-center justify-content-between">
                        <div className="col-10">
                            Retirar Boleto
                        </div>
                        <div className="col-2">
                            x
                        </div>
                    </button> */}
                    <button className="row m-0 accept align-items-center justify-content-between" onClick={() => updateTicket(2)}>
                        <div className="col-10">
                            Sellar ingreso
                        </div>
                        <div className="col-2">
                            {isLoading ?
                                    <div className="spinner-border" role="status" style={{height: '15px',
                                        width: '15px',
                                        fontSize: '10px',
                                        marginLeft: '10px'}}>
                                    </div>
                                :
                                    <img src={require('../../assets/arrownext.png')} alt="next" width="20px" />
                            }
                        </div>
                    </button>
                </div>
            </>
            :
            <div className="unavailable d-flex justify-content-between">
                <p className="m-0">Boleto escaneado</p>
                x
            </div>
            }
        </>    
        :
        <></>
    }
    
</div>);
}

export default ScanTicketView;